module.controller('userSignCtrl', [ '$scope', '$rootScope', '$state', '$timeout', '$window', 'userService', 'alertService', 'roleService', 'parameterService', 'userSignDataResolve', userSignCtrlFn ]);
function userSignCtrlFn($scope, $rootScope, $state,$timeout, $window, userService, alertService, roleService, parameterService, userSignData) {
	var vm = $scope;

	vm.userSignature = {};
	vm.signature = {
		isEmpty : true
	}
	vm.widthSignature = 1900;
	vm.heightSignature = 900;
	vm.loading = false;
	vm.edit = false;

	$timeout(function(){
		vm.heightSignature = 300;
	},1000);
	
	/*
	 * submit button
	 */
	vm.OnSubmit = function() {
		console.log("subbmit");
		var scopeChild = $scope.$$childTail;
		if (!$scope.$$childTail.accept)
			scopeChild = $scope.$$childHead;
		vm.signature = scopeChild.accept();

		console.log(vm.signature);

		if (vm.signature.isEmpty || angular.isUndefined(vm.signature.dataUrl)) {
			alertService.showSwtWarningQuestionRaw('Error en el formulario', 'por favor realice su firma sobre el componente', false, undefined);
			return;
		}

		var model = {
			signature : vm.signature.dataUrl
		}

		alertService.showSwtQuestion('Actualizar la firma', function() {
			vm.loading = true;
			userService.updateSignature(model).then(function(response) {

				getsignature();
				alertService.showSuccess('Firma actualizada satisfactoriamente');

				vm.signature = {
					isEmpty : true
				}
				scopeChild.clear();
				vm.edit = false;

				vm.loading = false;
			}, function(response) {
				vm.loading = false;
			});
		});
	}

	vm.getURLDataFromImage = function() {
		if (vm.takenInfo.takePhoto) {
			var file = Upload.base64DataUrl(vm.takenInfo.takePhoto);

			file.then(function(response) {
				vm.takenInfo.takePhoto.urlData = response;
				vm.loadPhoto = false;
			});
		} else {
			vm.loadPhoto = false;
		}
	}

	function getsignature() {
		vm.loading = true;
		userService.getSignature().then(function(response) {
			vm.userSignature = response.getData();
			vm.loading = false;
		}, function(response) {
			vm.loading = false;
		});
	}

	function init() {
		vm.userSignature = userSignData.getData();
	}

	init();
}
